import { render, staticRenderFns } from "./AdvertiserShow.vue?vue&type=template&id=1c458155&scoped=true"
import script from "./AdvertiserShow.vue?vue&type=script&lang=js"
export * from "./AdvertiserShow.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserShow.vue?vue&type=style&index=0&id=1c458155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c458155",
  null
  
)

export default component.exports